import React from 'react';
import { createRoot } from 'react-dom/client';
import LandingPagesVertical from '../../src/landing_pages_vertical/landing_pages_vertical';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('landing-pages-vertical');
  if (!container) return;
  const root = createRoot(container);

  root.render(
    <DevexHighOrderComponent>
      <LandingPagesVertical
        newsletter={JSON.parse(container.dataset.newsletter)}
        isSignedIn={JSON.parse(container.dataset.isSignedIn)}
      />
    </DevexHighOrderComponent>
  );
});
